import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackQuantityChangedInQuickOrderParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/quickOrder/trackQuantityChangedInQuickOrder";

const useTrackQuantityChangedInQuickOrder = (
    parameters: TrackQuantityChangedInQuickOrderParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.quantityChangedInQuickOrder, parameters, options);
};

export default useTrackQuantityChangedInQuickOrder;
